import React, { useContext } from 'react';
import {
  Button,
  Icon,
} from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';
import MemberEarlyAccessDescription from '../MemberEarlyAccessDescription/MemberEarlyAccessDescription';

export default function MemberEarlyAccessButton({ hasMemberEarlyAccessDescription = true }) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData,
    collectionData,
  } = ProductPageState;

  const {
    activeProduct,
  } = collectionData;

  const quickViewLogin = () => {
    document.dispatchEvent(new CustomEvent('authentication-modal:open', { detail: { isSignIn: true } }));
  };

  return (
    <div className="member-early-access-container" data-product-brand={activeProduct.brand} data-testid="member-early-access-button-container">
      {hasMemberEarlyAccessDescription && <MemberEarlyAccessDescription />}
      <Button
        classList="member-early-access-container_button"
        variant="primary"
        brand={activeProduct.brand}
        fullWidth
        onClick={quickViewLogin}
      >
        <Icon icon="lock-anf" />
        {tmntData.earlyAccessSignIn.value}
      </Button>
    </div>
  );
}
